export default __webpack_public_path__ + "static/media/image-3.04bedfa5.png";